/**
 * AiAssistedNote — the one label on internal work.
 *
 * The AI-for-users decision (2026-09-18 §5): a risk report, a compliance
 * scan, minutes for the team say they are AI-assisted, plainly, once. The
 * sentence is the server's (`ai_assisted_note` on the response) so the
 * wording is one place, per edition; this renders it quietly at the top of
 * the surface and renders nothing when the field is absent. It never goes
 * on a draft, an export or redline output — those the professional
 * adopts, and the page carries no banner.
 */
import { Sparkles } from 'lucide-react';

import { cn } from './cn';

interface AiAssistedNoteProps {
  note: string | null | undefined;
  className?: string;
}

export function AiAssistedNote({ note, className }: AiAssistedNoteProps) {
  const text = note?.trim();
  if (!text) return null;
  return (
    <p
      className={cn(
        'inline-flex items-start gap-1.5 text-xs leading-relaxed text-slate-500',
        className,
      )}
      role="note"
    >
      <Sparkles
        aria-hidden
        className="mt-0.5 shrink-0 text-[#A98330]"
        size={12}
        strokeWidth={1.75}
      />
      <span>{text}</span>
    </p>
  );
}
